<template>
<div>
  <a-list
    itemLayout="horizontal"
  >
    <a-list-item>
      <a-list-item-meta>
        <a slot="title">IM服务器</a>
        <span slot="description">
          <span class="security-list-description">
            当前 : wss://yun-api95d.nianchu.net:9292
          </span>
        </span>
      </a-list-item-meta>
      <template>
        <a slot="actions">
          <a>更换</a>
        </a>
      </template>
    </a-list-item>
  </a-list>
</div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  components:{},
  data () {
    return {}
  },
  computed: {
    google_auth() {
      const info = this.$store.state.user.info
      if(info['operate_info']['google_auth'] == true){
        return true
      }else{
        return false
      }
    }
  },
  methods: {
    ...mapGetters(['nickname']),
    bindGoogleAuth() {
      this.$refs.googleAuthModal.show()
    },
    cancelGoogleAuth() {
      
    }
  }
}
</script>

<style scoped>

</style>
